<div class="admin-page-link-container">
    <a class="link-button" (click)="onClick($event)">{{purgeType}}</a>
</div>